import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NonUniqueNameWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.client.validation.server-rule-violations.non-unique-name-warning');
    }
}
